import analytics from 'common/analytics';

import './register.style.sass';
import template from './register.tpl.pug';

class RegisterController {
    /* @ngInject */
    constructor($state, $window, sessionService, paymentService) {
        this.$state = $state;
        this.$window = $window;
        this.sessionService = sessionService;
        this.paymentService = paymentService;
        
        this.user = {
            name: '',
            email: '',
            password: ''
        };
        this.errors = {};
        this.loading = false;
        this.loadingMessage = '';
    }

    validateForm() {
        this.errors = {};
        let isValid = true;

        if (!this.user.name) {
            this.errors.name = 'Name is required';
            isValid = false;
        }

        if (!this.user.email) {
            this.errors.email = 'Email is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.email)) {
            this.errors.email = 'Please enter a valid email';
            isValid = false;
        }

        if (!this.user.password) {
            this.errors.password = 'Password is required';
            isValid = false;
        } else if (this.user.password.length < 8) {
            this.errors.password = 'Password must be at least 8 characters';
            isValid = false;
        }

        return isValid;
    }

    register() {
        if (this.validateForm()) {
            this.loading = true;
            this.errors = {};

            // First sign up the user
            this.sessionService.signUp(this.user.name, this.user.email, this.user.password)
                .then(() => {
                    analytics.trackSignUp();
                    
                    // Save registration info
                    this.onSubmit({
                        questionKey: 'registration',
                        answer: {
                            name: this.user.name,
                            email: this.user.email
                        }
                    });
                    
                    // Go directly to download
                    this.$state.go('conversion-quiz.download');
                })
                .catch((error) => {
                    let errorMessage;
                    if (error && error.data && error.data.error) {
                        errorMessage = error.data.error;
                    } else if (error && error.message) {
                        errorMessage = error.message;
                    } else if (error && typeof error === 'string') {
                        errorMessage = error;
                    } else {
                        errorMessage = 'An unexpected error occurred';
                    }
                    
                    this.loading = false;
                    this.errors.general = errorMessage;
                });
        }
    }
}

export default {
    template: template(),
    controller: RegisterController,
    bindings: {
        answers: '<',
        onSubmit: '&'
    },
    require: {
        quiz: '^dbConversionQuiz'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/register/register.cmpt.js